"use client";
import { useEffect, useRef } from "react";
import { ArrowLeft, FilterList, Xmark } from "iconoir-react";
import { useRouter, useSearchParams } from "next/navigation";
import { Button } from "@cappelendamm/design-system/react";
import { FacetList } from "./FacetList";
import { NumberOfHits } from "./NumberOfHits";
import { useItemListing } from "./ItemListingContext";

type FilterDialogProps = {
  facetsExpanded?: boolean;
};

export function FilterDialog({ facetsExpanded }: FilterDialogProps) {
  const router = useRouter();
  const searchParams = useSearchParams();
  const dialogRef = useRef<HTMLDialogElement>(null);
  const {
    nbHits,
    search: { query },
  } = useItemListing();
  const showFilters = searchParams.get("filters") === "open";

  useEffect(() => {
    const dialog = dialogRef.current;
    if (!dialog) return;

    if (showFilters) {
      dialog.showModal();
    } else {
      dialog.close();
    }
  }, [showFilters]);

  const handleOpen = () => {
    const params = new URLSearchParams(searchParams);
    params.set("filters", "open");
    router.replace(`?${params.toString()}`, { scroll: false });
  };

  const handleClose = () => {
    const params = new URLSearchParams(searchParams);
    params.delete("filters");
    router.replace(`?${params.toString()}`, { scroll: false });
  };

  return (
    <>
      <Button
        onClick={handleOpen}
        className="col-span-full mb-4 flex w-full items-center justify-center gap-x-4 md:hidden"
      >
        <FilterList />
        Filter
      </Button>
      <dialog
        ref={dialogRef}
        className="fixed top-0 left-0 h-screen w-screen auto-rows-min overflow-y-auto p-4 backdrop:bg-transparent open:grid md:hidden"
      >
        <button
          onClick={handleClose}
          className="flex h-12 w-12 items-center justify-center justify-self-end rounded-full bg-[#F7F7F8]"
        >
          <Xmark />
          <span className="sr-only">Vis treff</span>
        </button>
        <h2 className="text-2xl font-semibold">Filter</h2>
        <FacetList className="grid" initialExpanded={facetsExpanded} />
        <Button
          onClick={handleClose}
          className="col-span-full mt-4 flex w-fit items-center justify-center gap-x-4 justify-self-center md:hidden"
        >
          <ArrowLeft />
          <NumberOfHits
            template="Vis {numberOfHits} treff"
            nbHits={nbHits}
            query={query}
          />
        </Button>
      </dialog>
    </>
  );
}
